import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dot-loading',
  templateUrl: './dot-loading.component.html',
  styleUrls: ['./dot-loading.component.scss'],
  host: {
    '[class.inline]': 'inline',
    '[class.size-by-font]': 'sizeByFont',
    '[class.active]': 'active',
  },
})
export class DotLoadingComponent implements OnInit {
  constructor() {}

  @Input() inline: boolean = false;
  @Input() sizeByFont: boolean = true;
  @Input() active: boolean | null = true;

  ngOnInit() {}
}
